type IllustrationProps = { className?: string }

export default function IndividualSportGroup({ className }: IllustrationProps) {
  return (
    <svg
      viewBox="0 0 1400 1400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path fill="currentColor" transform="matrix(1,0,0,-1,482.2959,694.3054)" d="M252.27285 465.24205C370.9812 446.1647 451.74955 334.47038 432.67454 215.76203 413.5937 97.05368 301.90284 16.28534 183.1828 35.36035 64.474468 54.437685-16.293839 166.13202 2.79283 284.84034 21.870163 403.5487 133.56452 484.31706 252.27285 465.24205Z"/>
      <path fill="currentColor" transform="matrix(1,0,0,-1,319.2002,1173.7578)" d="M380.80003 476.1377C170.8 476.1377 0 298.47773 0 79.23773 .013672 52.636568 2.593135 26.104187 7.697302 .000031H753.89749C759.0016 26.104187 761.58096 52.636568 761.5947 79.23773 761.5947 298.47773 590.7947 476.1377 380.79469 476.1377H380.80003Z"/>
    </svg>
  )
}
